export enum ChannelOrPeopleContainerSelectedTab {
  yours = 'yours',
  discover = 'discover',
  invites = 'invites',
  archived = 'archived',
}